module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABLklEQVQ4T53Su0oDQRTG8f9kNyJ4aXRRE230AbwUIgiCoPgMovY2FhETJdU24oX1Ana2kbyDECzEQrDQBxALxexCtFECYtaMTHYEV+MuOOU532+GmTmCfy4RctlyEcS8rlWomcMcWm6zvcNw5bmT1vdrYLARlrJE+/Ectl3/icNQdVe9CQzOQSYDXN/ASe/EQ5XIlvMgNgNIDckke31X3/HvE1XXlgmqXgmYboSFuAVjjF3r9Qs3h6qbeUhjmjdAt77vCU5qKR7m7lPIpIKWhkWc1EI0tO0E1eVTkDM6eMdbyyhHXS/RMOeuI9kOQqLGhz/Ffv9l9ONk3HEMLhDo7xB5nN6t6O/IVTqQvhqAIX3aGW09s9giZgDWvAJCLurdn/D9EQ4GHuNHrlnij9on5hhVD0v9zzgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhengwu/z_icon_list01.png
// module id = tXsx
// module chunks = 1